export default __webpack_public_path__ + "static/meet-the-team-slide-4-c555d3b04472ca2b3c316e9ccb2c9d6e.jpg";